import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/styles";
import { map, sortBy, filter, get, includes } from "lodash";
import * as crypto from 'crypto-js';
import Grid from "@material-ui/core/Grid";

import FormSection from "../../Common/FormSection";
import MultipleFormSection from "./MultipleFormSection";

import { getAttributeValue, getAttributeValues } from "../../../utils/profile";
import { getAttributeName } from "../../../utils/attributes";

import { LANGUAGES } from "../../../constants/common";

const styles = {
  sectionCol: {
    padding: "10px 24px 0px 24px",
    minWidth: "248px",
    maxWidth: "308px",
  },
  formItem: {
    width: "260px",
    padding: "12px 24px",
  },
};

const HumanForm = (props) => {
  const {
    classes,
    section,
    data,
    lov,
    handleChange,
    validForm,
    errors,
    language,
    profileAttributes,
    profileValidationRules,
    permission
  } = props;
  const [isSha1Data, setSha1Data] = React.useState(null);
  React.useEffect(() => {
    const driverLicence = getAttributeValue(data, 39);
    handleChange(207, 0, driverLicence ? crypto.SHA1(driverLicence.toUpperCase().replace(/[^a-zA-Z0-9]/g, '')).toString() : undefined);
  }, [getAttributeValue(data, 39)]);

  React.useEffect(() => {
    if(data && getAttributeValue(data, 207)) {
      setSha1Data(getAttributeValue(data, 207));
    }
  }, []);

  const isValid = (id) => {
   
    if ((getAttributeValue(data, 39) ? getAttributeValue(data, 207) : true) && getAttributeValue(data, 31) && getAttributeValue(data, 32) && getAttributeValue(data, 35) && data['sys_tag_id']) {
      validForm[31] = true
      validForm[32] = true
      validForm[207] = true
      validForm[35] = true
      validForm['sys_tag_id'] = true
      validForm.form = true
      return true
    }  else {
      validForm.form = false
    }
    if (validForm && validForm[id]) {
      return true;
    }
    return false;
  };

  if (section === "main") {
    const attributes = sortBy(
      filter(
        profileAttributes,
        (attr) => get(attr, ["active"]) && get(attr, ["app_display_main_page"])
      ),
      (attr) => get(attr, ["app_display_seq_numb"])
    );
    return (
      <>
        <Grid container style={{ marginTop: "-5px" }}>
          <Grid item className={classes.formItem}>
            <FormSection
              formValue={[getAttributeValue(data, 31)]}
              setFormValue={handleChange}
              title2={getAttributeName(31)}
              id={31}
              options={{ required: true, redBorder: !isValid(31) }}
            />
          </Grid>
          <Grid item className={classes.formItem}>
            <FormSection
              formValue={[getAttributeValue(data, 32)]}
              setFormValue={handleChange}
              title2={getAttributeName(32)}
              id={32}
              options={{ required: true, redBorder: !isValid(32) }}
            />
          </Grid>
          <Grid item className={classes.formItem}>
            <FormSection
              formValue={[getAttributeValue(data, 195)]}
              setFormValue={handleChange}
              title2={getAttributeName(195)}
              id={195}
              permission={permission}
              options={{
                required: get(profileValidationRules, ["emailRequired"]),
                errorMsg: errors[195],
                redBorder:
                  (get(profileValidationRules, ["emailRequired"]) ||
                    getAttributeValue(data, 195)) &&
                  !isValid(195),
              }}
            />
          </Grid>
          <Grid item className={classes.formItem} style={{ width: "370px" }}>
            <MultipleFormSection
              id={34}
              typeId={194}
              title2={getAttributeName(34)}
              data={getAttributeValues(data, 34)}
              setFormValue={handleChange}
              lov={lov}
              language={language}
              errorMsg={errors[34]}
              required={get(profileValidationRules, ["phoneRequired"])}
              options={{
                errorMsg: errors[34],
                redBorder: !isValid(34),
              }}
            />
          </Grid>
        </Grid>
        <Grid container style={{ marginTop: "-5px" }}>
          <Grid item className={classes.formItem}>
            <FormSection
              formValue={[getAttributeValue(data, 35)]}
              setFormValue={handleChange}
              title2={getAttributeName(35)}
              id={35}
              type="select"
              options={{
                required: true,
                redBorder: !isValid[35],
                options:
                  lov[35] &&
                  lov[35].map((t) => ({
                    id: t.id,
                    name: t["name_" + language],
                  })),
              }}
            />
          </Grid>
          <Grid item className={classes.formItem}>
            <FormSection
              formValue={[getAttributeValue(data, 41)]}
              setFormValue={handleChange}
              title2={getAttributeName(41)}
              id={41}
            />
          </Grid>
          <Grid item className={classes.formItem}>
            <FormSection
              formValue={[data.sys_tag_id]}
              setFormValue={handleChange}
              title="tag"
              id="sys_tag_id"
              type="select"
              options={{
                required: true,
                redBorder: !isValid("sys_tag_id"),
                comboBox: true,
                options:
                  lov.tag &&
                  lov.tag.map((t) => ({
                    id: t.id,
                    name: t["name_" + language],
                  })),
              }}
            />
          </Grid>
        </Grid>
        <Grid container>
          {map(attributes, (attr) => (
            <Grid
              item
              key={attr.id}
              xs={3}
              style={{
                paddingBottom: "0px",
                padding: "10px 24px 0px 24px",
                minWidth: "248px",
                maxWidth: "308px",
              }}
            >
              <Grid container direction="column">
                <FormSection
                  formValue={[getAttributeValue(data, attr.id)]}
                  setFormValue={handleChange}
                  attribute={attr}
                  id={attr.id}
                  type={
                    includes(["radiobutton", "lov(picker)"], attr.data_type)
                      ? "select"
                      : attr.data_type === "boolean"
                      ? "boolean"
                      : "input"
                  }
                  options={{
                    redBorder: attr.required && !isValid(attr.id),
                    comboBox: attr.id === 89,
                    options: includes(
                      ["radiobutton", "lov(picker)"],
                      attr.data_type
                    )
                      ? map(
                          sortBy(lov[attr.id], (t) => t[`name_${language}`]),
                          (t) => ({
                            id: t.id,
                            name: t[`name_${language}`],
                          })
                        )
                      : null,
                  }}
                />
              </Grid>
            </Grid>
          ))}
        </Grid>
      </>
    );
  }

  if (section === "secondary") {
    const attributes = sortBy(
      filter(
        profileAttributes,
        (attr) => get(attr, ["active"]) && !get(attr, ["app_display_main_page"])
      ),
      (attr) => get(attr, ["app_display_seq_numb"])
    );
    return (
      <>
        <Grid container>
          <Grid
            item
            xs={3}
            className={classes.sectionCol}
            style={{ paddingBottom: "0px" }}
          >
            <Grid container direction="column">
              <FormSection
                formValue={[getAttributeValue(data, 20)]}
                setFormValue={handleChange}
                title2={getAttributeName(20)}
                id={20}
              />
              <FormSection
                formValue={[getAttributeValue(data, 23)]}
                setFormValue={handleChange}
                title2={getAttributeName(23)}
                id={23}
              />
              <FormSection
                formValue={[getAttributeValue(data, 26)]}
                setFormValue={handleChange}
                title2={getAttributeName(26)}
                id={26}
              />
              <FormSection
                formValue={[getAttributeValue(data, 24)]}
                setFormValue={handleChange}
                title2={getAttributeName(24)}
                id={24}
              />
              <FormSection
                formValue={[getAttributeValue(data, 27)]}
                setFormValue={handleChange}
                title2={getAttributeName(27)}
                id={27}
              />
            </Grid>
          </Grid>
          <Grid
            item
            xs={3}
            className={classes.sectionCol}
            style={{ paddingBottom: "0px" }}
          >
            <Grid container direction="column">
              <FormSection
                formValue={[getAttributeValue(data, 39)]}
                setFormValue={(id, index, value) => {
                  const isMatch = !value ? true : /^[a-zA-Z0-9- ]+$/gi.test(value);
                  if(value.length <= 20 && isMatch) {
                    setSha1Data(null);
                    handleChange(id, index, value.replace(/\s\s/gi, ' ').replace(/--/gi, '-'));
                  }
                }}
                title2={getAttributeName(39)}
                id={39}
                options={{ required: false}}
                permission={permission}
              />
              <FormSection
                formValue={[getAttributeValue(data, 36)]}
                setFormValue={handleChange}
                title2={getAttributeName(36)}
                id={36}
                type="select"
                options={{
                  options:
                    lov[36] &&
                    lov[36].map((t) => ({
                      id: t.id,
                      name: t["name_" + language],
                    })),
                }}
              />
              <FormSection
                formValue={[getAttributeValue(data, 19)]}
                setFormValue={handleChange}
                title2={getAttributeName(19)}
                id={19}
                options={{ multiline: true, height: "200px" }}
              />
            </Grid>
          </Grid>
          <Grid
            item
            xs
            className={classes.sectionCol}
            style={{ maxWidth: "570px", paddingBottom: "0px" }}
          >
            <Grid container direction="column">
              <MultipleFormSection
                id={37}
                typeId={133}
                title2={getAttributeName(37)}
                data={getAttributeValues(data, 37)}
                setFormValue={handleChange}
                lov={lov}
                language={language}
                options={{
                  errorMsg: errors[37],
                  redBorder: !isValid(37),
                }}
              />
              <MultipleFormSection
                id={38}
                typeId={134}
                title2={getAttributeName(38)}
                data={getAttributeValues(data, 38)}
                setFormValue={handleChange}
                lov={lov}
                language={language}
                options={{
                  errorMsg: errors[38],
                  redBorder: !isValid(38),
                }}
              />
              <MultipleFormSection
                id={50}
                typeId={135}
                title2={getAttributeName(50)}
                data={getAttributeValues(data, 50)}
                setFormValue={handleChange}
                lov={lov}
                language={language}
                
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid container>
          {map(attributes, (attr) => (
            <Grid
              item
              key={attr.id}
              xs={3}
              style={{
                paddingBottom: "0px",
                padding: "10px 24px 0px 24px",
                minWidth: "248px",
                maxWidth: "308px",
              }}
            >
              <Grid container direction="column">
                <FormSection
                  formValue={[getAttributeValue(data, attr.id)]}
                  setFormValue={(id, index, value, subValue) => {
                    if(id === 207) {
                      if(!value || /^[0-9a-fA-F]+$/.test(value) && value.length <= 40) {
                        setSha1Data(null);
                        handleChange(id, index, value, subValue);
                      }
                  } else {
                    handleChange(id, index, value, subValue)}
                  }}
                  attribute={attr}
                  id={attr.id}
                  type={
                    includes(["radiobutton", "lov(picker)"], attr.data_type)
                      ? "select"
                      : attr.data_type === "boolean"
                      ? "boolean"
                      : "input"
                  }
                  options={{
                    redBorder: attr.id === 207 ? (isSha1Data || isSha1Data === undefined)  ? !isValid(207) : !validForm[207]: attr.required && !isValid(attr.id),
                    errorMsg: errors[attr.id],
                    comboBox: attr.id === 89,
                    options: includes(
                      ["radiobutton", "lov(picker)"],
                      attr.data_type
                    )
                      ? map(
                          sortBy(lov[attr.id], (t) => t[`name_${language}`]),
                          (t) => ({
                            id: t.id,
                            name: t[`name_${language}`],
                          })
                        )
                      : null,
                  }}
                />
              </Grid>
            </Grid>
          ))}
        </Grid>
      </>
    );
  }

  return null;
};

HumanForm.propTypes = {
  section: PropTypes.oneOf(["main", "secondary"]).isRequired,
  data: PropTypes.object.isRequired,
  lov: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
  validForm: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  language: PropTypes.oneOf(LANGUAGES),
};

export default withStyles(styles)(HumanForm);
